import loadable from '@loadable/component';

export const CircleApplication = loadable(() => import('./CircleApplication'));
export const CircleCreation = loadable(() => import('./CircleCreation'));
